import { createReducer } from "../utils";
import {
  SET_ALERTS,
  SET_ALERT_MESSAGE,
  UPDATING_ALERTS,
  REMOVE_ALERT_MESSAGE,
  HOMEPAGE_ALERT_SUCCESS,
  HOMEPAGE_ALERT_DISMISS
} from "../constants";

// Individual alerts should follow the format: {level: <success|info|warn|error>, message: <message>}
const initialState = {
  data: [],
  updatingAlerts: false,
  homepage: {
    id: null,
    url: null,
    feed_id: null,
    feed: null,
    message: null,
    duration: null,
    created_on: null,
    start_date: null,
    end_date: null,
    now: null
  },
  dismissedHomepageAlerts: []
};

export default createReducer(initialState, {
  [SET_ALERTS]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.data,
      updatingAlerts: false
    });
  },
  [SET_ALERT_MESSAGE]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.data,
      updatingAlerts: false
    });
  },
  [REMOVE_ALERT_MESSAGE]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.data,
      updatingAlerts: false
    });
  },
  [UPDATING_ALERTS]: (state, payload) => {
    return Object.assign({}, state, {
      updatingAlerts: true
    });
  },
  [HOMEPAGE_ALERT_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      homepage: payload.data
    });
  },
  [HOMEPAGE_ALERT_DISMISS]: (state, payload) => {
    let dismissedAlerts = state.dismissedHomepageAlerts;
    dismissedAlerts.push(payload.data);
    return Object.assign({}, state, {
      dismissedHomepageAlerts: dismissedAlerts,
      homepage: initialState.homepage
    });
  }
});
